import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AUTH_VERSION } from "../utils/localStoarege";
import * as Yup from "yup";
import logo from "../assets/icons/full-logo.png";
import loginBackground from "../assets/images/background_login.png"; // Replace with your image path
import { accountLoginApi, loginApi, medicalLoginApi } from "../services/clinic/auth";
import { toast } from "react-toastify";
import InputField from "../components/inputFields/InputField";
import Button from "../components/buttons/Button";
import Dropdown from "../components/inputFields/DropDown";
import { hudLogin } from "../services/hud/hud_auth";
import { initializeApp } from "@firebase/app";
import { getMessaging, getToken } from "@firebase/messaging";

const Signin = () => {
    const navigate = useNavigate();
    const [hidePassword, setHidePassword] = useState(true);
    const [loginType, setLoginType] = useState("Admin Login");

    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const payload = {
                username: values.username,
                password: values.password,
            };
            if (loginType === "Clinic Login") {
                const response = await loginApi(payload);
                const responseData = response?.data;
                if (response?.status === 200) {
                    localStorage?.setItem("auth_token", responseData?.token);
                    localStorage?.setItem("user_name", responseData.center);
                    localStorage?.setItem("role", responseData?.role.toLowerCase());
                    localStorage?.setItem("auth_version", AUTH_VERSION);
                    navigate("/package-invoice");
                    window.location.reload();
                } else {
                    let errors = "Username or password is incorrect";
                    toast.error(errors);
                }
                resetForm();
            } else if (loginType === "HUD Login") {
                const response = await hudLogin(payload);
                const responseData = response?.data;
                if (response?.status === 200) {
                    localStorage?.setItem("auth_token", responseData?.token);
                    localStorage?.setItem("role", responseData?.role.toLowerCase());
                    localStorage?.setItem("auth_version", AUTH_VERSION);
                    navigate("/home");
                    window.location.reload();
                } else {
                    let errors = "Username or password is incorrect";
                    toast.error(errors);
                }
                resetForm();
            } else if (loginType === "Account Login") {

                const firebaseConfig = {
                    apiKey: "AIzaSyB0XFM3qQbWaU2hol76AOGcF8oUOwwe5RA",
                    authDomain: "mvrc-app.firebaseapp.com",
                    projectId: "mvrc-app",
                    storageBucket: "mvrc-app.firebasestorage.app",
                    messagingSenderId: "1077050228249",
                    appId: "1:1077050228249:web:2e822c8bf92fc5fb6e3488",
                    measurementId: "G-3CGMKV84Z9"
                };
                const firebaseApp = initializeApp(firebaseConfig);
                const messaging = getMessaging(firebaseApp);
                const response = await accountLoginApi({ ...payload, fcm_token: await getToken(messaging) });
                const responseData = response?.data;
                if (response?.status === 200) {
                    localStorage?.setItem("auth_token", responseData?.token);
                    localStorage?.setItem("user_name", responseData.center);
                    localStorage?.setItem("role", responseData?.role.toLowerCase());
                    localStorage?.setItem("auth_version", AUTH_VERSION);
                    navigate("/account/home");
                    window.location.reload();
                } else {
                    let errors = "Username or password is incorrect";
                    toast.error(errors);
                }
                resetForm();
            } else if (loginType === "Medical Login") {
                const response = await medicalLoginApi(payload);
                const responseData = response?.data;
                if (response?.status === 200) {
                    localStorage?.setItem("auth_token", responseData?.token);
                    localStorage?.setItem("user_name", responseData?.center || responseData?.username || "");
                    localStorage?.setItem("role", responseData?.role?.toLowerCase() || "medical");
                    localStorage?.setItem("auth_version", AUTH_VERSION);
                    navigate("/medical/home");
                    window.location.reload();
                } else {
                    let errors = "Username or password is incorrect";
                    toast.error(errors);
                }
                resetForm();
            } else {
                const response = await hudLogin(payload);
                const responseData = response?.data;
                if (response?.status === 200) {
                    localStorage?.setItem("auth_token", responseData?.token);
                    localStorage?.setItem("role", responseData?.role.toLowerCase());
                    localStorage?.setItem("auth_version", AUTH_VERSION);
                    navigate("/doctor/home");
                    window.location.reload();
                } else {
                    let errors = "Username or password is incorrect";
                    toast.error(errors);
                }
                resetForm();
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    const togglePassword = () => {
        setHidePassword(!hidePassword);
    };

    useEffect(() => {
        if (window.location.pathname.length > 1) {
            setLoginType(window.location.pathname.replaceAll('/', '').replaceAll('%20', ' '));
        }
        const token = localStorage?.getItem("auth_token") || "";
        const role = localStorage?.getItem("role") || "";
        if (token.length > 1) {
            if (role === "clinic") {
                window.location = "/package-invoice";
            } else if (role === "hud") {
                window.location = "/home";
            } else if (role === "accountant") {
                window.location = "/account/home";
            } else if (role === "medical") {
                window.location = "/medical/home";
            } else if (role === "doctor" || role === "admin") {
                window.location = "/doctor/home";
            } else {
                window.location = "/package-invoice";
            }
        }
    }, []);

    const handleLoginChange = (value) => {
        setLoginType(value);
    };
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
            style={{
                backgroundImage: `url(${loginBackground})`,
            }}
        >
            {/* Overlay for better contrast */}
            <div className="absolute inset-0 bg-black bg-opacity-20"></div>

            {/* Login form */}
            <div className="relative bg-white p-6 rounded-lg shadow-lg w-full max-w-xs z-10">
                <img src={logo} alt="Logo" className="mb-1 h-12 mx-auto" />
                <div className="flex flex-row justify-center items-center gap-2">
                    <hr className="border-secondary flex-1" />
                    <Dropdown
                        placeholder={loginType}
                        options={
                            loginType === "Clinic Login"
                                ? [
                                    { label: "Admin View", value: "Admin View" },
                                    { label: "HUD Login", value: "HUD Login" },
                                    { label: "Account Login", value: "Account Login" },
                                    { label: "Medical Login", value: "Medical Login" },
                                ]
                                : loginType === "HUD Login"
                                    ? [
                                        { label: "Admin View", value: "Admin View" },
                                        { label: "Clinic Login", value: "Clinic Login" },
                                        { label: "Account Login", value: "Account Login" },
                                        { label: "Medical Login", value: "Medical Login" },
                                    ]
                                    : loginType === "Account Login"
                                        ? [
                                            { label: "Admin View", value: "Admin View" },
                                            { label: "Clinic Login", value: "Clinic Login" },
                                            { label: "HUD Login", value: "HUD Login" },
                                            { label: "Medical Login", value: "Medical Login" },
                                        ]
                                        : loginType === "Medical Login"
                                            ? [
                                                { label: "Admin View", value: "Admin View" },
                                                { label: "Clinic Login", value: "Clinic Login" },
                                                { label: "HUD Login", value: "HUD Login" },
                                                { label: "Account Login", value: "Account Login" },
                                            ]
                                            : [
                                                { label: "Clinic Login", value: "Clinic Login" },
                                                { label: "HUD Login", value: "HUD Login" },
                                                { label: "Account Login", value: "Account Login" },
                                                { label: "Medical Login", value: "Medical Login" },
                                            ]
                        }
                        onChange={(value) => handleLoginChange(value)}
                    />
                    <hr className="border-secondary flex-1" />
                </div>
                <Formik
                    initialValues={{
                        username: "",
                        password: "",
                        rememberMe: false,
                    }}
                    validationSchema={Yup.object({
                        username: Yup.string().required("Please enter your Username"),
                        password: Yup.string().required("Please enter your password"),
                    })}
                    onSubmit={handleFormSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="mb-1">
                                <InputField
                                    label="Username"
                                    name="username"
                                    type="text"
                                    placeholder="Enter your username"
                                    required
                                />
                            </div>
                            <div className="mb-1">
                                <InputField
                                    label="Password"
                                    name="password"
                                    type={hidePassword ? "password" : "text"}
                                    placeholder="Enter your password"
                                    required
                                    isPassword={true}
                                    showPassword={!hidePassword}
                                    onPasswordToggle={togglePassword}
                                />
                            </div>
                            {
                                loginType === "Account Login" ?
                                    <></> :
                                    // <div
                                    //     className="text-white bg-secondary hover:opacity-80 font-medium rounded-lg text-lg w-full py-2 text-center cursor-pointer"
                                    //     onClick={() => { }}
                                    // >
                                    //     {"Send OTP"}
                                    // </div> :
                                    <Button
                                        type="submit"
                                        className="text-white bg-primary hover:opacity-80 text-xs"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "Loading..." : "Login"}
                                    </Button>
                            }
                            {
                                loginType === "Account Login" ?
                                    <>
                                        {/* <div className="mb-4">
                                            <InputField
                                                label="OTP"
                                                name="otp"
                                                type={hidePassword ? "password" : "text"}
                                                placeholder="OTP Here"
                                                required
                                                isPassword={true}
                                                showPassword={!hidePassword}
                                                onPasswordToggle={togglePassword}
                                            />
                                        </div> */}
                                        <Button
                                            type="submit"
                                            className="text-white bg-primary hover:opacity-80 rounded text-xs"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Loading..." : "Login"}
                                        </Button>
                                    </> : <></>
                            }
                        </Form>
                    )}
                </Formik>
                <p className="mt-3 text-center text-[10px] text-gray-500">
                    Developed by Rashail Tech Labs 2026
                </p>
            </div>
        </div>
    );
};

export default Signin;
